<template>
  <div>
    <el-drawer
      :modal="false"
      :visible.sync="drawer"
      :with-header="true"
      :modal-append-to-body="false"
      size="65%"
    >
      <h3 slot="title">床位标签项管理</h3>
      <div
        class="scroll-bar"
        style="padding: 0px 20px; overflow: auto; height: 100vh"
      >
        <el-button size="small" type="primary" @click="handleNew">{{
          $t("app.new")
        }}</el-button>
        <el-table :data="tableData" stripe style="width: 100%" height="85%">
          <el-table-column
            align="center"
            :label="$t('app.bedTags.code')"
            prop="Code"
          ></el-table-column>
          <el-table-column
            align="center"
            :label="$t('app.bedTags.name')"
            prop="Name"
          ></el-table-column>
          <el-table-column
            align="center"
            :label="$t('app.enable')"
            prop="IsUse"
          >
            <template slot-scope="scope">
              {{ scope.row.IsUse }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="300"
            :label="$t('app.bedTags.description')"
            prop="Description"
          >
          </el-table-column>
          <el-table-column
            align="right"
            width="150px"
            :label="$t('app.operation')"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleEdit(scope.$index, scope.row)"
                >{{ $t("app.edit") }}</el-button
              >
              <el-button
                size="small"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >{{ $t("app.delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :title="$t('app.delete')"
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          width="30%"
        >
          <span>{{ $t("app.isDelete") + "(" + name + ")" }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button
              size="small"
              type="info"
              @click="dialogVisible = false"
              >{{ $t("app.cancel") }}</el-button
            >
            <el-button
              size="small"
              type="primary"
              :loading="loading"
              @click="deleteBedTagsItem()"
              >{{ $t("app.confirm") }}</el-button
            >
          </span>
        </el-dialog>
        <BedTags-item-modal
          ref="bedTagsItemModal"
          @handleSuccess="updateBedTagsItem"
          @handleAdd="addBedTagsItem"
        ></BedTags-item-modal>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import BedTagsItemModal from "./BedTagsItemModal";
import { del, GetChildrent } from "@/api/systemManagement/bedTagsManagement";
export default {
  components: {
    BedTagsItemModal
  },
  data() {
    return {
      drawer: false,
      options: [
        {
          value: true,
          label: this.$t("app.isUse")
        },
        {
          value: false,
          label: this.$t("app.disable")
        }
      ],
      size: 10,
      currentPage: 1,
      total: 100,
      loading: false,
      dialogVisible: false,
      deleteIndex: "",
      tableData: [],
      schoolYear: "",
      id: "",
      pid: "",
      name: "",
      rowInfo: {}
    };
  },
  methods: {
    async visible(row) {
      //console.log(row);
      this.pid = row.Id;
      this.schoolYear = row.SchoolYear;
      this.rowInfo = row;
      // this.tableData = row.child.map((_) => {
      //   return {
      //     description: _.Description,
      //     typeCode: _.DictTypeCode,
      //     name: _.DictText,
      //     code: _.DictCode,
      //     enable: _.IsUse,
      //     sort: _.SortNumber,
      //   };
      // });
      const data = await GetChildrent({ pid: row.Id, isUse: "all" });
      //console.log("#######$$$$$$$$$$");
      //console.log(data);
      this.tableData = data.data;
      // this.tableData = data.data.map(_ => {
      //   return {
      //     Description: _.Description,
      //     SchoolYear: _.SchoolYear,
      //     Name: _.Name,
      //     Code: _.Code,
      //     enable: _.IsUse,
      //     sort: _.SortNumber
      //   };
      // });
      this.drawer = true;
    },
    handleEdit(index, row) {
      this.$refs.bedTagsItemModal.edit(index, row);
    },
    updateBedTagsItem(index, obj) {
      this.tableData.splice(index, 1, obj);
    },
    handleDelete(index, row) {
      this.dialogVisible = true;
      this.code = row.Code;
      this.name = row.Name;
      this.schoolYear = row.SchoolYear;
      this.id = row.Id;
    },
    deleteBedTagsItem() {
      this.loading = true;
      del({ id: this.id })
        .then(() => {
          this.loading = false;
          this.dialogVisible = false;
          this.tableData.splice(this.deleteIndex, 1);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleNew() {
      this.$refs.bedTagsItemModal.add(this.pid, this.schoolYear);
    },
    addBedTagsItem(obj) {
      console.log(obj);
      this.tableData.push(obj);
    }
  }
};
</script>
